const KeyCode: Object = {
  Space: 32,
  Enter: 13,
  Esc: 27,
  Left: 37,
  Right: 39,
  Up: 38,
  Down: 40,
  Tab: 9,
};
export default KeyCode;
